import React from "react";
import { useSelector } from "react-redux";
import TableRow from "./TableRow";

export default function Tbody() {
  const flights = useSelector((state) => state.flights);
  return (
    <tbody className="divide-y divide-gray-300/20" id="lws-previewBooked">
      {flights.map((flight) => (
        <TableRow key={flight.id} flight={flight} />
      ))}
    </tbody>
  );
}
